const SortListLoading = () => {
  return <div className='h-7 w-30 animate-pulse rounded bg-gray-100 lg:h-9' data-sentry-component="SortListLoading" data-sentry-source-file="loading.tsx" />;
};
export default SortListLoading;